// material-ui
import { Theme } from '@mui/material/styles';

// project imports
import { withAlpha } from 'utils/colorUtils';

// ==============================|| OVERRIDES - OUTLINED INPUT ||============================== //

export default function OutlinedInput(theme: Theme, borderRadius: number, outlinedFilled: boolean) {
  // Use explicit colors for light mode to avoid CSS variable issues
  const lightModeBg = outlinedFilled ? '#f8fafc' : 'transparent';
  const darkModeBg = outlinedFilled ? 'rgba(255, 255, 255, 0.04)' : 'transparent';

  return {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: lightModeBg,
          borderRadius: `${borderRadius}px`,

          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.12)',
            ...theme.applyStyles('dark', {
              borderColor: 'rgba(255, 255, 255, 0.12)'
            })
          },

          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.2)',
            ...theme.applyStyles('dark', {
              borderColor: 'rgba(255, 255, 255, 0.2)'
            })
          },

          '&.MuiInputBase-multiline': {
            padding: 1
          },

          ...theme.applyStyles('dark', {
            background: darkModeBg
          })
        },
        input: {
          fontWeight: 500,
          background: lightModeBg,
          padding: '15.5px 14px',
          borderRadius: `${borderRadius}px`,
          color: '#1e293b',

          '&::placeholder': {
            color: '#94a3b8',
            opacity: 1
          },

          '&.MuiInputBase-inputSizeSmall': {
            padding: '10px 14px',

            '&.MuiInputBase-inputAdornedStart': {
              paddingLeft: 0
            }
          },

          ...theme.applyStyles('dark', {
            background: darkModeBg,
            color: '#fafafa',
            '&::placeholder': {
              color: 'rgba(255, 255, 255, 0.4)',
              opacity: 1
            }
          })
        },
        inputAdornedStart: {
          paddingLeft: 4
        },
        notchedOutline: {
          borderRadius: `${borderRadius}px`
        }
      }
    }
  };
}
